import { CALENDAR_START_DATE } from "@dailywars/core/entitlements/mapAccess";

export type ProfileActivityFill = "empty" | "standard" | "premium" | "both" | "unavailable";

export function isCalendarDateAvailable(date: string): boolean {
  return date >= CALENDAR_START_DATE;
}

function variantCompleted(bestDays: number | null | undefined): boolean {
  return typeof bestDays === "number";
}

function resolveProfileActivityFill({
  standardCompleted,
  premiumCompleted,
}: {
  standardCompleted: boolean;
  premiumCompleted: boolean;
}): ProfileActivityFill {
  if (standardCompleted && premiumCompleted) return "both";
  if (standardCompleted) return "standard";
  if (premiumCompleted) return "premium";
  return "empty";
}

export function profileActivityFillLabel(fill: ProfileActivityFill): string {
  switch (fill) {
    case "standard":
      return "Standard completed";
    case "premium":
      return "Premium completed";
    case "both":
      return "Both completed";
    case "empty":
      return "Not completed";
    case "unavailable":
      return "Not available";
  }
}

export function resolveActivityFillFromCompletion({
  date,
  standardCompleted,
  premiumCompleted,
}: {
  date: string;
  standardCompleted: boolean;
  premiumCompleted: boolean;
}): ProfileActivityFill {
  if (!isCalendarDateAvailable(date)) return "unavailable";
  return resolveProfileActivityFill({ standardCompleted, premiumCompleted });
}

export function resolveActivityFillFromCalendarDay({
  date,
  day,
}: {
  date: string;
  day?: {
    standard: { bestDays: number | null };
    premium: { bestDays: number | null };
  };
}): ProfileActivityFill {
  if (!isCalendarDateAvailable(date)) return "unavailable";
  if (!day) return "empty";
  return resolveProfileActivityFill({
    standardCompleted: variantCompleted(day.standard.bestDays),
    premiumCompleted: variantCompleted(day.premium.bestDays),
  });
}
